import { fmtUsd } from "../lib/format";
import { CoinsIcon, LightningIcon, TrophyIcon, TrendUpIcon } from "@phosphor-icons/react";

const Stat = ({ icon: Icon, label, value, sub, color = "#00E599", testid }) => (
  <div data-testid={testid} className="border border-white/10 bg-card p-4 sm:p-5 flex items-start gap-4 hover:border-white/30 transition-colors duration-150">
    <div className="w-10 h-10 flex items-center justify-center border border-white/10 shrink-0" style={{ color }}>
      <Icon size={22} weight="bold" />
    </div>
    <div className="min-w-0">
      <div className="text-[11px] uppercase tracking-wider text-muted-foreground">{label}</div>
      <div className="font-mono font-bold text-xl sm:text-2xl mt-0.5 truncate" style={{ color }}>{value}</div>
      {sub && <div className="text-xs text-muted-foreground mt-0.5 truncate">{sub}</div>}
    </div>
  </div>
);

export const MarketStats = ({ stats, loading }) => {
  if (loading || !stats) {
    return (
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
        {[0, 1, 2, 3].map((i) => (
          <div key={i} className="border border-white/10 bg-card p-5 h-[92px] animate-pulse" />
        ))}
      </div>
    );
  }
  return (
    <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
      <Stat testid="stat-coins" icon={CoinsIcon} label="Tracked Coins" value={stats.totalCoins} color="#fff" />
      <Stat testid="stat-volume" icon={LightningIcon} label="24h Volume" value={fmtUsd(stats.totalVolume)} color="#00E599" />
      <Stat testid="stat-avg" icon={TrophyIcon} label="Avg Degen Score" value={stats.avgScore} sub={`${stats.strongCount} high-confidence`} color="#F5A623" />
      <Stat
        testid="stat-gainer"
        icon={TrendUpIcon}
        label="Top Gainer 24h"
        value={stats.topGainer?.symbol || "—"}
        sub={stats.topGainer ? `+${(stats.topGainer.change ?? 0).toFixed(1)}%` : ""}
        color="#00E599"
      />
    </div>
  );
};
